export default {
    pagination: {
        pageNum: 1,
        pageSize: 50,
        total: 0,
        paginationkey: 0
    },
    searchlist: [
        {
            prop: 'keyWord',
            label: '关键字',
            type: 'input'
        }
    ],
    searchdata: {
        keyWord: ''
    },
    headData: [
        {
            title: '公司代码',
            prop: 'companyCode',
            width: 110,
            custom: true

        },
        {
            title: '公司名称',
            prop: 'nsrmc',
            width: 130,
            custom: true

        },
        {
            title: '纳税人识别号',
            prop: 'nsrsbh',
            width: 130,
            custom: true

        }
    ]
};
